import * as api from "../../api/leaguesSelectorApi";
import store from "../../store/store";
const LeaguesModel = {
  state: {
    selectAll: true,
    popularCompetitions: [] as Array<any>,
    otherCompetitions: [] as Array<any>,
    selectedComps: [] as Array<any>,
    totalNumberComps: 0,
    showComponent: false,
    isLoading: false,
  },
  reducers: {
    getLeaguesSuccess(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        otherCompetitions: payload.otherCompetitions,
        popularCompetitions: payload.popularCompetitions,
        totalNumberComps: payload.totalNumberComps,
        selectedComps: payload.selectedComps,
        isLoading: false,
      };
    },

    getLeaguesRequest(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        isLoading: true,
      };
    },

    updateSelectedComps(
      state: Record<string, any>,
      payload: Record<string, any>
    ): any {
      return {
        ...state,
        selectAll: payload.selectAll,
        selectedComps: payload.selectedComps,
      };
    },
  },
  effects: {
    async getLeagues(rootState: Record<string, any>) {
      this.getLeaguesRequest();
      let compIds = store.getState().competitionListModel.compIds;
      api
        .fetchLeagues() // ARCH-136 remove passed params as already exist in store
        .then(resp => {
          const popularCompsIds =
            (resp.popularCompetitions &&
              resp.popularCompetitions.map(comp => comp.id)) ||
            [];
          const otherCompsIds =
            (resp.otherCompetitions &&
              resp.otherCompetitions.map(comp => comp.id)) ||
            [];
          const totalNumberComps = popularCompsIds.concat(otherCompsIds).length;
          const selectedComps =
            compIds && compIds.length > 0
              ? compIds
              : popularCompsIds.concat(otherCompsIds);
          this.getLeaguesSuccess({
            otherCompetitions: resp.otherCompetitions,
            popularCompetitions: resp.popularCompetitions,
            totalNumberComps: totalNumberComps,
            selectedComps: selectedComps,
          });
        });
    },
  },
};
export default LeaguesModel;
